import BaseService from "@/api/services/BaseService";
import type ServiceInterface from "@/api/services/ServiceInterface";
import type { RestoreBackupParams } from "@/types/backup";

const maxUploadTimeout = import.meta.env.VITE_API_MAX_BACKUP_TIMEOUT || 180000;

export default class ServiceBackup
  extends BaseService
  implements ServiceInterface
{
  async exportBackup(): Promise<any> {
    const headers = {
      'Content-Type': 'application/octet-stream',
    }

    let url = '/api/system/backup/export';

    const response = await this.rest.request({
      url: url,
      method: "get",
      data: {}, // It's necessary for send headers
      responseType: 'blob',
      headers: headers
    });
    return {'data': response.data, 'headers': response.headers};
  }

  async restoreBackup(    
    params: RestoreBackupParams,
    file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const data = new FormData();
      data.append("file", file);

      let parameters = '';

      if (params.merge === true) {
        parameters = `?merge=${params.merge}`
      }

      this.rest
        .request({
          method: "put",
          url: `/api/system/backup/restore${parameters}`,
          data,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }, maxUploadTimeout)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          if (this.rest.isUploadError(error)) {
            error;
          }
          reject(error);
        });
    });
  }
}